import React from "react";
import { Data } from "../../../../components/Formatters/DateTime";

const columns = [
  {
    name: "Linha",
    selector: "linha",
    minWidth: "50px",
    center: true,
    sortable: true,
    omit: true,
  },
  {
    name: "Nº PAT",
    selector: "nuPat",
    minWidth: "130px",
    center: true,
    sortable: true,
  },
  {
    name: "Situação do PAT",
    selector: "stProcesso",
    minWidth: "130px",
    center: true,
    sortable: true,
  },
  {
    name: "Decisão Condenatória",
    selector: "nuDecisao",
    minWidth: "130px",
    center: true,
    sortable: true,
  },
  {
    name: "Data da Ciência da Decisão",
    selector: "dtCiencia",
    minWidth: "140px",
    center: true,
    sortable: true,
    cell: (row) => <Data value={row.dtCiencia} />,
  },
  {
    name: "Sistema",
    selector: "sistema",
    minWidth: "130px",
    center: true,
    sortable: true,
  },
];

const useColumns = () => ({ columns });

export default useColumns;
